module.exports = __webpack_public_path__ + "static/img/3320_phase_function_Paper_PointsHejduk_Prediction.a7af06b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3320_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 6nNB
// module chunks = 0